import React, { useRef, useEffect } from "react"
import * as d3 from "d3"

interface PieChartProps {
  piedata: { label: string; value: number; color: string }[]
}

const PieChart: React.FC<PieChartProps> = ({ piedata }) => {
  const ref = useRef<SVGSVGElement | null>(null)

  useEffect(() => {
    const svg = d3.select(ref.current)
    const width = 200
    const height = 200
    const radius = Math.min(width, height) / 3

    const colors: { [key: string]: string } = {
      "Principal & Interest": "#264283",
      "Mortgage Insurance": "#DB9247",
    }

    const pie = d3
      .pie<{ label: string; value: number; color: string }>()
      .value((d: any) => d.value)

    const arc = d3
      .arc<d3.PieArcDatum<{ label: string; value: number }>>()
      .innerRadius(0)
      .outerRadius(radius)

    svg.selectAll("*").remove()

    const g = svg
      .append("g")
      .attr("transform", `translate(${width / 2},${height / 2})`)

    const arcs = g
      .selectAll(".arc")
      .data(pie(piedata))
      .enter()
      .append("g")
      .attr("class", "arc")

    arcs
      .append("path")
      .attr("d", arc)
      .attr("fill", (d: any) => colors[d.data.label])
      .on("mouseover", function (event: any, d: any) {
        const [x, y] = arc.centroid(d)
        tooltip
          .style("left", `${event.pageX}px`)
          .style("top", `${event.pageY}px`)
          .style("display", "inline-block")
          .html(
            `<div style="text-align:center; color:${d.data.color}"><p>${d.data.label}</p><p>$${d.data.value}</p></div>`
          )
      })
      .on("mouseout", function () {
        tooltip.style("display", "none")
      })

    const tooltip = d3
      .select("body")
      .append("div")
      .attr("class", "tooltip")
      .style("position", "absolute")
      .style("background", "#fff")
      .style("border", `1px solid #264283`)
      .style("padding", "10px")
      .style("display", "none")
  }, [piedata])

  return (
    <div>
      <svg ref={ref} width="200" height="200"></svg>
    </div>
  )
}

export default PieChart
